import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const pages = () => import('./automation-pages');

// Automation rules (Zendesk triggers). Owned by the automation module.
export const routes: RouteObject[] = [
  { path: 'automation', lazy: page(pages, (m) => m.RulesPage) },
  { path: 'automation/runs', lazy: page(pages, (m) => m.RunsPage) },
];
export const orgRoutes: RouteObject[] = [];
